<template>
  <div>
    <div class="hideOperationContainer" @click="toggleMenu">{{show?$t('actions.hide')+' &gt;':'&lt;'+$t('actions.expansion')}}</div>
    <div v-show="show" class="rightMenu">
      
      <div class="rightMenu-btn personalCenterOne">
        <NuxtLink  :to="userCenterHomePath">  
          <div class="container">
            <img class="normal-icon" src="/assets/imgs/user.png" style />
            <img class="active-icon" src="/assets/imgs/user-white.png"   />
            <div class="info-text" >{{$t('texts.userCenter')}}</div>
            
          </div>
        </NuxtLink>
      </div>
      <div class="rightMenu-btn cart">
        <NuxtLink :to="mallCartPath" @click="rememberWdCartTabIfNeeded">  
          <div class="container">
            <img  class="normal-icon" src="/assets/imgs/cart.png" style />
            <img class="active-icon" src="/assets/imgs/cart-white.png"   />
            <div class="info-text" >{{$t("texts.buyCart")}}</div>
          </div>
        </NuxtLink>
      </div>
      <!-- <div class="rightMenu-btn issueOrder">
        <div class="container">
          <img class="normal-icon" src="/assets/imgs/goodsComparisonIcon.svg" />
          <img
            class="active-icon" 
            src="/assets/imgs/goodsComparisonActiveIcon.svg" 
          />
          <div class="info-text" >比較</div>
          
        </div>
      </div> -->
   
      <!-- <div class="rightMenu-btn warehouse">
        <NuxtLink  :to="`/sub/mall/message`">  
          <div class="container">
            <img class="normal-icon" src="/assets/imgs/informNoHover.svg" />
            <img class="active-icon" src="/assets/imgs/informHover.svg"   />
            <div class="info-text" >{{$t('texts.messageCenter')}}</div>
            
          </div>
        </NuxtLink>
      </div> -->
      <div class="rightMenu-btn order">
        <NuxtLink  :to="userCenterOrdersPath">  
          <div class="container">
            <img class="normal-icon" src="/assets/imgs/order.png" />
            <img class="active-icon" src="/assets/imgs/order-white.png"   />
            <div class="info-text" >{{$t('texts.orderCenter')}}</div>
            
          </div>
        </NuxtLink>
      </div>
      <div class="rightMenu-btn chat">
        <NuxtLink  :to="`/v?url=contact`">  
          <div class="container">
            <img class="normal-icon" src="/assets/imgs/rakuchatGrey.png"   />
            <img class="active-icon" src="/assets/imgs/rakuchatWhite.png" style="display: none;" />
            <div class="info-text" >{{$t('texts.contactClient')}}</div>
            
          </div>
        </NuxtLink>
      </div>
    </div>
    <ScrollTopBottomBar v-show="show"  />
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from "vue";
import { useMainStore, } from "~/composables/store";
import { Menu, Search, Close } from "@element-plus/icons-vue";
import { useRoute } from "vue-router";
import { get } from "lodash-es"; 
import { $t } from "~/utils/index.js";
import ScrollTopBottomBar from "./ScrollTopBottomBar.vue";
import { legacyPathToUserCenterPath } from "~/user-center/routes";
const store = useMainStore();
const route = useRoute();
const ERP_MALL_CART_TAB_KEY = "erp_mall_cart_default_tab";
const userCenterHomePath = legacyPathToUserCenterPath("/mall/home");
const userCenterOrdersPath = legacyPathToUserCenterPath("/mall/allOrderList");
 
const show = ref(true);
const name="FixedRightBar";
const mallCartPath = computed(() => {
  const currentPath = String(route.path || "");
  return legacyPathToUserCenterPath(currentPath.startsWith("/wd") ? "/mall/cart?tab=wd" : "/mall/cart");
});
function rememberWdCartTabIfNeeded(){
  if (!process.client) return;
  const currentPath = String(route.path || "");
  if (currentPath.startsWith("/wd")) {
    window.localStorage.setItem(ERP_MALL_CART_TAB_KEY, "wd");
  }
}
function toggleMenu(){
  show.value=!show.value;
}
</script>

<style scoped lang="less">
.hideOperationContainer {
  width: 60px;
  height: 26px;
  background: linear-gradient(180deg, #f04d52, #b4272b);
  border-radius: 4px 0 0 4px;
  position: fixed;
  top: 24%;
  right: 0;
  line-height: 24px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  cursor: pointer;
  z-index: 999;
}

.rightMenu {
  position: fixed;
  right: 0;
  top: 28%;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  box-shadow: 0 0 20px 0 rgba(61, 61, 61, 0.1);
  width: 60px;
  height: 240px;
  z-index: 999;
  background-color: #fff;
  align-items: flex-end;
  .rightMenu-btn{
    cursor: pointer;
    width: 60px;
    height: 60px;
    border-bottom: 1px solid #dfdfdf;
    display: flex;
    justify-content: center;
    align-items: center;
    &:first-child{
      
      border-top-left-radius: 10px;
     
      
    }
    &:last-child{
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      border-bottom:none;
    }
    &:hover{
      background-color: #b4272b;
      min-width: 152px;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      justify-content: flex-start;
      .container{
        padding: 0 20px;
        justify-content: flex-start;
        .normal-icon{
          display: none;
        }
        .active-icon{
          display: block !important;
        }
        .info-text{
          display: block !important;
        }
      }
    }
    .container{
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .normal-icon{
      width: 21px;
      height: 24px;
    }
    .info-text{
      margin-left: 10px;
      font-size: 14px;
      display: none;
      color:#fff;
    }
    .active-icon{
      width: 21px;
      display: none;
      height: 24px;
    }
  }
}


 
</style>
